import React from 'react'
import PropTypes from 'prop-types'
import { DateToggle } from 'components/DateToggle'
import { TimeDropdown } from 'components/TimeDropdown'
import * as R from 'ramda'
import { getWorkspaceTimezoneLabel } from 'libs/date'

const transformDateArrayToObject = (days, day) => ({ ...days, [day]: true })

export class DeliveryWindowInput extends React.Component {
  static propTypes = {
    defaultValue: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
  }

  static defaultProps = {
    defaultValue: {
      send_window_days: [],
    },
    onChange: () => {},
  }

  setStateAndTriggerOnChangeForKey = (key) => (state) => {
    this.setState({ [key]: state }, () => {
      this.props.onChange(
        /* prettier-ignore */
        R.over(
          R.lensProp('send_window_days'),
          R.compose(Object.keys, R.filter(R.equals(true)))
        )(
          this.state
        )
      )
    })
  }

  state = {
    send_window_days: this.props.defaultValue.send_window_days.reduce(
      transformDateArrayToObject,
      {}
    ),
    send_window_start: this.props.defaultValue.send_window_start || '00:00:00',
  }

  render() {
    const timezone = getWorkspaceTimezoneLabel()
    return (
      <div className="ui form">
        <div className="field">
          <DateToggle
            defaultValue={this.state.send_window_days}
            onChange={this.setStateAndTriggerOnChangeForKey('send_window_days')}
          />
        </div>
        <div className="fields">
          <div className="field">
            <TimeDropdown
              defaultValue={this.state.send_window_start}
              onChange={this.setStateAndTriggerOnChangeForKey('send_window_start')}
            />
            <p className="mt2 h5 text-grey">{timezone}</p>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/DeliveryWindowInput/index.js